<template>
  <div id="pesquisa" class="b-laranja p-20">
    <div class="container">
      <h1 class="text-center text-uppercase branco">{{$store.state.option['pesquisar-' + lang]}}</h1>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
          <div class="row p-v-20" style="padding-bottom:0px;">
            <div class="col-lg-4 col-md-4 p-v-5">
              <select class="form-control" v-model="form.levantamento" @change="form.entrega = form.levantamento">
                <option value="" disabled selected hidden>{{$store.state.option['levantamento-' + lang]}}</option>
                <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
              </select>
            </div>
            <div class="col-lg-4 col-md-4 p-v-5">
              <date-picker value-type="timestamp" required v-model="form.date" @change="handleChangeDate" :disabled-date="notBeforeDate" :clearable="false" :editable="false" type="date" :format="$store.state.option.date_format" :lang="langData" :placeholder="$store.state.option['levantamento_data-' + lang]"></date-picker>
            </div>
            <div class="col-lg-4 col-md-4 p-v-5">
              <date-picker required v-model="form.time" :open.sync="open" @change="handleChange" :clearable="false" :editable="false" type="time" format="HH:mm" :minute-step="10" :placeholder="$store.state.option['levantamento_hora-' + lang]"></date-picker>
            </div>

            <div class="col-lg-4 col-md-4 p-v-5">
              <select class="form-control" v-model="form.entrega">
                <option value="" disabled selected hidden>{{$store.state.option['devolucao-' + lang]}}</option>
                <option :value="dt.StationID" v-for="(dt, index) in estacoes" :key="index">{{dt.Station}}</option>
              </select>
            </div>
            <div class="col-lg-4 col-md-4 p-v-5">
              <date-picker value-type="timestamp" required v-model="form.date1" :disabled-date="notBeforeDate1" :clearable="false" :editable="false" type="date" :format="$store.state.option.date_format" :lang="langData" :placeholder="$store.state.option['devolucao_data-' + lang]"></date-picker>
            </div>
            <div class="col-lg-4 col-md-4 p-v-5">
              <date-picker required v-model="form.time1" :clearable="false" :editable="false" type="time" format="HH:mm" :minute-step="10" :placeholder="$store.state.option['devolucao_hora-' + lang]" :open.sync="open1" @change="handleChange1"></date-picker>
            </div>
          </div>
          <div class="clearfix"></div>
          <div class="row">
            <div :class="{'col-lg-8 col-md-8': form.driver !== 'add', 'col-lg-8 col-md-8': form.driver !== 'add', 'p-v-5': 1}" v-if="$store.state.user" style="margin:0px;padding:0px;">
              <select id="driver" v-model="form.driver" class="form-control" v-if="$store.state.user.role === 'client'">
                <option selected value="">{{$store.state.option['reserved-seleccionarCondutor-' + lang]}}</option>
                <option :value="dt.DriverID" v-for="(dt, index) in drivers" :key="index">{{dt.Driver_Name}} ({{dt.City}})</option>
                <option value="add">{{$store.state.option['reserved-add-driver-' + lang]}}</option>
              </select>
            </div>
            <div class="col-lg-8 p-v-5" v-if="form.driver === 'add'">
              <input type="text" class="form-control" v-model="form.condutor" :placeholder="$store.state.option['reserved-nome-condutor-' + lang]" />
            </div>

            <div class="col-lg-4 col-md-4" v-if="!$store.state.user || form.driver === 'add'">
                <label style="margin-top:7px;float:right;color:#fff;">{{$store.state.option['aniversario-' + lang]}}</label>
            </div>
            <div class="col-lg-4 col-md-4"  v-if="!$store.state.user || form.driver === 'add'">
                <input type="text" class="form-control" :disabled-date="notBeforeDateAniversario" :editable="false" v-model="form.aniversario" :placeholder="$store.state.option['date_of_Birth-' + lang]" v-mask="date_mask_local" required="required" />
            </div>

            <div class="col-lg-4 col-md-4">
               <button @click="reservar()" style="padding: 0px;height:100%;border-color:#fff;" type="button" class="btn-lg btn btn-primary sembordas btn-block">{{$store.state.option['search_botao-' + lang]}} <i class="fas fa-search m-l-15"></i></button>
            </div>
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'
import birthDate from '../mixins/birthDate'

export default {
  mixins: [birthDate],
  data () {
    return {
      estacoes: {},
      form: {
        date: '',
        date1: '',
        time: new Date('2000/10/10 10:00:00'),
        time1: new Date('2000/10/10 10:00:00'),
        levantamento: '',
        entrega: '',
        aniversario: '',
        driver: '',
        condutor: ''
      },
      langData: {},
      lang: '',
      open: false,
      open1: false,
      drivers: [],
      date_mask_local: '####-##-##',
      formattedBirthDate: ''
    }
  },
  mounted () {
    this.SET_LOAD(true)
    this.init()
  },
  methods: {
    ...mapMutations([
      'SET_LOAD',
      'SET_AVISO'
    ]),
    handleChangeDate () {
      let d = new Date(this.form.date)
      d.setDate(d.getDate() + 7)
      this.form.date1 = new Date(d).getTime()
    },
    notBeforeDateAniversario (date) {
      return date > new Date()
    },
    init () {
      if (this.$store.state.option1 && this.$store.state.stations1) {
        this.date_mask_local = this.$store.state.option.date_mask
        this.estacoes = this.$store.state.stations
        this.lang = this.$store.state.lang
        this.langData = {
          days: [this.$store.state.option['sun-' + this.lang], this.$store.state.option['mon-' + this.lang], this.$store.state.option['tue-' + this.lang], this.$store.state.option['wed-' + this.lang], this.$store.state.option['thu-' + this.lang], this.$store.state.option['fri-' + this.lang], this.$store.state.option['sat-' + this.lang]],
          months: [this.$store.state.option['jan-' + this.lang], this.$store.state.option['fev-' + this.lang], this.$store.state.option['mar-' + this.lang], this.$store.state.option['apr-' + this.lang], this.$store.state.option['may-' + this.lang], this.$store.state.option['jun-' + this.lang], this.$store.state.option['jul-' + this.lang], this.$store.state.option['aug-' + this.lang], this.$store.state.option['sep-' + this.lang], this.$store.state.option['out-' + this.lang], this.$store.state.option['nov-' + this.lang], this.$store.state.option['dec-' + this.lang]]
        }
        this.form.time = new Date('2000/10/10 10:00:00')
        this.form.time1 = new Date('2000/10/10 10:00:00')

        if (this.$store.state.user1) {
          if (this.$store.state.user.role === 'client') {
            if (this.$store.state.drivers1) {
              this.drivers = this.$store.state.drivers
            } else {
              this._.delay(this.init, 100)
            }
          }
        }
      } else {
        this._.delay(this.init, 100)
      }
    },
    handleChange (value, type) {
      if (type === 'minute') {
        this.open = false
      }
    },
    handleChange1 (value, type) {
      if (type === 'minute') {
        this.open1 = false
      }
    },
    notBeforeDate (date) {
      return date < new Date().setDate(new Date().getDate() - 1)
    },
    notBeforeDate1 (date) {
      return date < new Date(this.form.date)
    },
    reservar () {
      // if (this.$store.state.option.date_format === 'YYYY-MM-DD' && !/[12]\d{3}-(0[1-9]|1[0-2])-(0[1-9]|[12]\d|3[01])/.test(this.form.aniversario) && !this.$store.state.user) {
      //   this.SET_AVISO(this.$store.state.option['erro-aniversario_pattern-' + this.lang] || 'Please insert the birthday date with the following pattern: yyyy-mm-dd')
      //   return
      // }
      // verify which date format is used in vuex:
      if (!this.checkAndTransformBirthDate(this.form.aniversario)) {
        return
      } else {
        this.form.aniversario = this.birthDayFromMixin
      }
      let a = new Date(this.form.date)
      let b = new Date(this.form.date1)
      let a1 = new Date(this.form.time)
      let b1 = new Date(this.form.time1)
      let aniversario = new Date(this.formattedBirthDate)
      let x = 0
      if (this.form.levantamento) {
        if (this.form.date) {
          if (this.form.date1) {
            if (this.$store.state.user) {
              if (this.$store.state.user.role === 'client') {
                x = 'c'
              }
              if (this.$store.state.user.role === 'driver') {
                x = 'd'
              }
            }
            if ((((this.form.aniversario && this.form.driver === 'add') || (this.form.driver && this.form.driver !== 'add')) && x === 'c') || x === 'd' || (this.form.aniversario && !this.$store.state.user)) {
              // this.$localStorage.remove('reserva')
              this.$router.push('/reserved?l=' + this.form.levantamento + '&d=' + this.form.entrega + '&dt=' + a.getFullYear() + '/' + (+a.getMonth() + 1) + '/' + a.getDate() + ' ' + a1.getHours() + ':' + a1.getMinutes() + '&dt1=' + b.getFullYear() + '/' + (+b.getMonth() + 1) + '/' + b.getDate() + ' ' + b1.getHours() + ':' + b1.getMinutes() + '&b=' + aniversario.getFullYear() + '/' + (+aniversario.getMonth() + 1) + '/' + aniversario.getDate() + '&dd=' + this.form.driver + '&cd=' + this.form.condutor, () => {})
            } else {
              if (this.form.driver === 'add' || !this.$store.state.user) {
                this.SET_AVISO(this.$store.state.option['erro-aniversario-' + this.lang])
              } else {
                this.SET_AVISO(this.$store.state.option['erro-driver-' + this.lang])
              }
            }
          } else {
            this.SET_AVISO(this.$store.state.option['erro-devolucaoData-' + this.lang])
          }
        } else {
          this.SET_AVISO(this.$store.state.option['erro-levantamentoData-' + this.lang])
        }
      } else {
        this.SET_AVISO(this.$store.state.option['erro-levantamento-' + this.lang])
      }
    }
  }
}
</script>
